import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/case-groups.js';
import q from '../query.js';
export const caseGroupsEntity = 'case-groups';
const getCaseGroupsKey = `get-case-groups`;
export const useCaseGroups = () => q.query(getCaseGroupsKey, () => api.getAllCaseGroups(), keys.read.collection(caseGroupsEntity));
//# sourceMappingURL=index.js.map